import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MaterialTypography from "../../components/MaterialTypography";
import {
  Cancel,
  CheckCircle,
  Dashboard,
  Error,
  Info,
} from "@mui/icons-material";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialBox from "../../components/MaterialBox";
import MaterialSelect from "../../components/MasterSelect";
import MaterialInput from "../../components/MaterialInput";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BASEURL from "../Utils/Baseurl";
import { useLoading } from "../../context/loading";
import { fetchAll } from "../../ApiBaseUrl";

function Increment() {
  const navigate = useNavigate(); 
  const columns = [
    {
      field: "EmpId",
      headerName: "Emp Id",
      width: 150,
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "UserName",
      headerName: "User Name",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "Category",
      headerName: "Category",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "Type",
      headerName: "Employee Type",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "Branch",
      headerName: "Branch",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "createdBy",
      headerName: "Created By",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    // {
    //   field: "incrementActive",
    //   headerName: "Active",
    //   flex: 1,
    //   disableColumnMenu: true,
    //   editable: false,
    //   sortable: true,
    //   renderCell: (params) => (
    //     <Box
    //       sx={{
    //         display: "flex",
    //         alignItems: "center",
    //         backgroundColor: params.row.incrementActive ? "#39b54a" : "#bdbdbd",
    //         color: "#07170a",
    //         padding: "4px 8px",
    //         borderRadius: "12px",
    //         fontSize: "0.8rem",
    //         fontWeight: 500,
    //         width: "fit-content",
    //       }}
    //     >
    //       {params.row.incrementActive ? (
    //         <CheckCircle style={{ fontSize: "16px", marginRight: "4px" }} />
    //       ) : (
    //         <Cancel style={{ fontSize: "16px", marginRight: "4px" }} />
    //       )}
    //       {params.row.incrementActive ? "Active" : "Inactive"}
    //     </Box>
    //   ),
    // },
  ];
  const categoryOptions = [
    { value: "Category 1", label: "Category 1" },
    { value: "Category 2", label: "Category 2" },
    { value: "Category 3", label: "Category 3" },
    { value: "Category 4", label: "Category 4" },
  ];
  const typeOptions = [
    { value: "Staff", label: "Staff" },
    { value: "Operators", label: "Operators" },
  ];
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const { circleLoading, setCirleLoading } = useLoading();
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    category: "",
    employeeType: "",
    branch: "",

    startDateStatus: "unchecked",
    endDateStatus: "unchecked",
    categoryStatus: "unchecked",
    employeeTypeStatus: "unchecked",
    branchStatus: "unchecked",
  });

  const handleRowClick = (e) => {
    if (e?.id) {
      navigate("/increment/increment-data", {
        state: { id: e?.id },
      });
    }
  };

  const fetchData = async () => {
    setCirleLoading(true);
    try {
      const response = await axios.post(BASEURL, {
        query: `
          query get_filter($start_date: Date, $end_date: Date, $category: String, $employee_type: String, $branch: String) {
            filterIncrement(startDate: $start_date, endDate: $end_date, category: $category, employeeType: $employee_type, branch: $branch) {
              data {
              id
                employee {
                id
                  empid
                  firstName
                  lastName
                  category
                  employeeType
                  branch
                }
                basicAmount
                daAmount
                mealsAmountPerDay
                otAmountPerHour
                shiftPaisa
                attendanceAmount
                busFare
                createdBy{
                  id
                  firstName
                  lastName
                }
                createdAt
                incrementActive
              }
            }
          }
        `,
        variables: {
          start_date: filters.startDate || null,
          end_date: filters.endDate || new Date().toISOString().split("T")[0],
          category: filters.category?.value || null,
          employee_type: filters.employeeType?.value || null,
          branch: filters.branch?.value || null,
        },
      });

      const result = response.data.data.filterIncrement.data || [];

      setRows(
        result.map((item, index) => ({
          id: item?.employee.id,
          EmpId: item.employee.empid,
          UserName: `${item.employee.firstName} ${item.employee.lastName}`,
          Category: item.employee.category,
          Type: item.employee.employeeType,
          Branch: item.employee.branch,
          createdBy: item.createdBy?.firstName,
          createdAt: formatDate(item.createdAt.slice(0, 10)),
          incrementActive: (
            // <Box
            //   sx={{
            //     display: "flex",
            //     alignItems: "center",
            //     backgroundColor: item.incrementActive ? "#39b54a" : "#bdbdbd",
            //     color: "#07170a",
            //     padding: "4px 8px",
            //     borderRadius: "12px",
            //     marginTop: "15px",
            //     fontSize: "0.8rem",
            //     fontWeight: 500,
            //     width: "fit-content",
            //   }}
            // >
            //   {item.incrementActive ? (
            //     <CheckCircle style={{ fontSize: "16px", marginRight: "4px" }} />
            //   ) : (
            //     <Cancel style={{ fontSize: "16px", marginRight: "4px" }} />
            //   )}
            //   {item?.incrementActive ? "Active" : "Inactive"}
            // </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: item.incrementActive ? "#39b54a" : "#bdbdbd",
                color: "#07170a",
                padding: "4px 8px",
                borderRadius: "12px",
                marginTop: "15px",
                fontSize: "0.8rem",
                fontWeight: 500,
                width: "fit-content",
              }}
            >
              {item.incrementActive ? (
                <CheckCircle style={{ fontSize: "16px", marginRight: "4px" }} />
              ) : (
                <Cancel style={{ fontSize: "16px", marginRight: "4px" }} />
              )}
              {item.incrementActive === true ? "Active" : "Inactive"}
            </Box>
          ),
        }))
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  useEffect(() => {
    if (Object.values(filters).some((value) => value)) {
      fetchData();
    }
  }, [filters]);
  const [branchList, setBranchList] = useState([]);

  useEffect(() => {
    const fetchBranches = async () => {
      setCirleLoading(true);
      try {
        const fields = [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ];
        const data = await fetchAll("Branch", fields);
        setBranchList(data?.allBranch);
      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        setCirleLoading(false);
      }
    };

    fetchBranches();
  }, []);

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Increment Details
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "20vh" }}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={1}
            padding={1}
          >
            {/* Start Date */}
            <Grid item xs={12} sm={6} md={3}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Start Date
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="startDate"
                type="date"
                value={filters.startDate}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    startDate: e.target.value,
                    startDateStatus: e.target.value ? "success" : "unchecked",
                  })
                }
                success={filters.startDateStatus === "success" ? true : false}
              />
            </Grid>

            {/* End Date */}
            <Grid item xs={12} sm={6} md={3}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  End Date
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="endDate"
                type="date"
                value={filters.endDate}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    endDate: e.target.value,
                    endDateStatus: e.target.value ? "success" : "unchecked",
                  })
                }
                inputProps={{
                  min:filters.startDate,
                  // max: new Date().toISOString().split("T")[0],
                }}
                success={filters.endDateStatus === "success" ? true : false}
                disabled={!filters.startDate}
              />
            </Grid>

            {/* Category */}
            <Grid item xs={12} sm={6} md={6}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Category
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="category"
                options={categoryOptions}
                value={filters.category}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    category: e?.target?.value || e,
                    categoryStatus:
                      e?.target?.value || e ? "success" : "unchecked",
                  })
                }
                success={filters.categoryStatus === "success" ? true : false}
                isClearable
              />
            </Grid>

            {/* Employee Type */}
            <Grid item xs={12} sm={6} md={6}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Employee Type
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="employeeType"
                options={typeOptions}
                value={filters.employeeType}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    employeeType: e?.target?.value || e,
                    employeeTypeStatus:
                      e?.target?.value || e ? "success" : "unchecked",
                  })
                }
                success={
                  filters.employeeTypeStatus === "success" ? true : false
                }
                isClearable
              />
            </Grid>

            {/* Branch */}
            <Grid item xs={12} sm={6} md={6}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Branch
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="branch"
                options={branchList.map((item) => ({
                  value: item.name,
                  label: item.name,
                }))}
                value={filters.branch}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    branch: e?.target?.value || e,
                    branchStatus:
                      e?.target?.value || e ? "success" : "unchecked",
                  })
                }
                success={filters.branchStatus === "success" ? true : false}
                isClearable
              />
            </Grid>
          </Grid>
        </CardContent>

        {/* Table */}
        <MaterialDataGrid
          rows={rows || null}
          columns={columns || null}
          loading={loading}
          isSelectable={false}
          onRowClick={handleRowClick}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Increment Report found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any Increment details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
}

export default Increment;
